import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0089',
    ecrans: ['00-2'],
    params: ['elgcleintref', 'vaesyselg']
});
